export class DisconnectCustomerVaultAccountResponse {
    'customerVaultAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "customerVaultAccount",
            "baseName": "customerVaultAccount",
            "type": "CustomerVaultAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectCustomerVaultAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
